import { FiSearch } from "react-icons/fi";
import Input from "@components/Input";

export function ARInvoiceReviewFilters({
  searchVal,
  onSearchChange,
  statusFilter,
  onStatusChange,
  periodStart,
  onPeriodStartChange,
}: {
  searchVal: string;
  onSearchChange: (val: string) => void;
  statusFilter: string;
  onStatusChange: (val: string) => void;
  periodStart: string;
  onPeriodStartChange: (val: string) => void;
}) {
  return (
    <div className="tw-bg-white dark:tw-bg-[#0D1117] tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-p-2 tw-mb-2">
      <div className="tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-between tw-gap-2">
        <div className="tw-flex tw-flex-col tw-gap-1 md:tw-flex-row md:tw-items-center md:tw-gap-1 md:tw-flex-wrap">
          <div className="tw-w-full md:tw-w-96">
            <Input
              icon={FiSearch}
              containerStyle={{ marginRight: 0, width: "100%", height: 28 }}
              id="ar-invoice-review-search"
              type="text"
              name="search"
              placeholder="search"
              onChange={(e: any) => onSearchChange(e.target.value)}
              disabled={false}
              value={searchVal}
            />
          </div>
          <div className="tw-flex tw-items-center tw-gap-1 tw-w-full md:tw-w-auto">
            <label className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300">
              Status:
            </label>
            <select
              value={statusFilter}
              onChange={(e) => onStatusChange(e.target.value)}
              className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827]"
            >
              <option value="">All</option>
              <option value="Review">Review</option>
              <option value="Finalized">Finalized</option>
              <option value="Zero Hours">Zero Hours</option>
              <option value="Zero Amount">Zero Amount</option>
              <option value="Missing">Missing</option>
            </select>
          </div>
        </div>

        <div className="tw-flex tw-items-center tw-gap-1">
          <label className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300">
            Pay Period:
          </label>
          <input
            type="date"
            value={periodStart}
            onChange={(e) => onPeriodStartChange(e.target.value)}
            className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827] tw-w-32"
          />
        </div>
      </div>
    </div>
  );
}
